import { render } from "./MSightViewer.vue?vue&type=template&id=60cd24af&scoped=true"
import script from "./MSightViewer.vue?vue&type=script&lang=js"
export * from "./MSightViewer.vue?vue&type=script&lang=js"

import "./MSightViewer.vue?vue&type=style&index=0&id=60cd24af&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cd24af"]])

export default __exports__